/** How long the object URL outlives the click: Safari and Firefox have been seen reading it late. */
export const REVOKE_AFTER_MS = 4000

/** Save a blob under a filename via a transient anchor. The URL is revoked later, never at once: a revoked one is an empty file. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  try {
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()
  } finally {
    window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS)
  }
}
